export const Props = () => ({
  //Имя элемента формы
  name: {
    type: String,
    required: false,
  },

  //Подпись текстового поля
  label: {
    type: String,
    required: false,
  },

  //Дополнительная подпись текстового поля
  option: {
    type: String,
    required: false,
  },

  //Отключить поле
  disabled: {
    type: Boolean,
    required: false,
  },

  //Текст заглушка поля
  placeholder: {
    type: String,
    required: false,
  },

  //Ограничение по кол-ву символов в поле
  maxSybmols: {
    type: Number,
    required: false,
  },

  isCounterBottom:{
    type: Boolean,
  },

  //Текст ошибки для поля
  errorMessage: {
    type: String,
    required: false,
  },

  //Тип поля (input / textarea)
  type: {
    type: String,
    required: false,
    default: 'input',
  },

  //Значения для инициализации
  initValue: {
    type: String,
    required: false,
  },

  //Только цифровой формат
  onlyDigital: {
    type: Boolean,
    default: false,
  },

  //Поле обязательное для ввода?
  required: {
    type: Boolean,
    default: false,
  },

  //Значение для передачи значения в родительскую форму, для валидации
  modelValue: {
    type: [String, Boolean],
    required: false,
    default: '',
  },
})
